type Props = { fill?: string; size?: number };

const CheckedIcon = ({ fill, size = 20 }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" rx="6" fill={fill ?? "#1064DB"} />
      <path
        d="M14.725 5.725L7.75 12.7L5.275 10.225C4.975 9.925 4.525 9.925 4.225 10.225C3.925 10.525 3.925 10.975 4.225 11.275L7.225 14.275C7.375 14.425 7.525 14.5 7.75 14.5C7.975 14.5 8.125 14.425 8.275 14.275L15.775 6.775C16.075 6.475 16.075 6.025 15.775 5.725C15.475 5.425 15.025 5.425 14.725 5.725Z"
        fill="white"
      />
    </svg>
  );
};

export default CheckedIcon;
